import IconBool from "components/IconBool";

const DivIconValue = ({item, field, _TC}) => (
    <div className="d-inline-block text-center ps-2 pe-3 border-end">
        <div className="fw-medium">{_TC(`fields.${field}.short`)}</div>
        <div>
            <IconBool value={item.has[field]} /> <span className="ms-2">{item.values[field]}</span>
        </div>
    </div>
);
export default DivIconValue;
